import { jsx as _jsx } from "react/jsx-runtime";
import { useRef } from 'react';
import clsx from 'clsx';
import { useMeasure } from '@tribeplatform/react-ui-kit/hooks';
const clamp = (min, value, max) => Math.min(Math.max(value, min), max);
const calculate = ({ naturalHeight, naturalWidth, height, width, cropY, }) => {
    if (!(width > 0 && height > 0 && naturalWidth > 0 && naturalHeight > 0)) {
        return {
            translateY: cropY,
            width: undefined,
            height: undefined,
        };
    }
    const mediaAspect = naturalWidth / naturalHeight;
    const calculatedHeight = width / mediaAspect;
    const cropBound = Math.abs(calculatedHeight - height) / 2;
    const translateY = cropBound > 0 ? clamp(0 - cropBound, cropY, cropBound) : cropY;
    return { translateY, width, height: calculatedHeight };
};
export const LegacyBanner = ({ banner, className }) => {
    var _a, _b, _c, _d, _e;
    const [wrapperRef, { width, height }] = useMeasure();
    const imageRef = useRef();
    const imageWidth = (_a = imageRef.current) === null || _a === void 0 ? void 0 : _a.naturalWidth;
    const imageHeight = (_b = imageRef.current) === null || _b === void 0 ? void 0 : _b.naturalHeight;
    const src = (_d = (_c = banner.urls) === null || _c === void 0 ? void 0 : _c.large) !== null && _d !== void 0 ? _d : banner.url;
    const cropY = (_e = banner.cropY) !== null && _e !== void 0 ? _e : 0;
    const { translateY, width: calculatedWidth } = calculate({
        naturalHeight: imageHeight,
        naturalWidth: imageWidth,
        height,
        width,
        cropY,
    });
    return (_jsx("div", { ref: wrapperRef, className: clsx('overflow-hidden flex items-center transition-colors', className), style: {
            backgroundColor: banner.dominantColorHex,
        }, children: _jsx("img", { ref: imageRef, src: src, style: {
                transform: `translate(0px, ${translateY}px)`,
                opacity: calculatedWidth > 0 ? 100 : 0,
            }, className: "w-full h-auto", alt: "" }, void 0) }, void 0));
};
//# sourceMappingURL=LegacyBanner.js.map